import { render, staticRenderFns } from "./QuestionUploadMedia.vue?vue&type=template&id=6af7b93c&scoped=true"
import script from "./QuestionUploadMedia.vue?vue&type=script&lang=js"
export * from "./QuestionUploadMedia.vue?vue&type=script&lang=js"
import style0 from "./QuestionUploadMedia.vue?vue&type=style&index=0&id=6af7b93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af7b93c",
  null
  
)

export default component.exports